module.exports = __webpack_public_path__ + "static/images/styles/images/nations/china-cn.90d23202.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/china-cn.png
// module id = 3657
// module chunks = 11